import { withZod } from '@remix-validated-form/with-zod'
import { z } from 'zod'

// `(555) 123-4567` as the phone input formats it, or the raw ten digits.
const phonePattern = /^(\(\d{3}\) \d{3}-\d{4}|\d{10})$/

const baseSchema = z.object({
  id: z.string(),
  email: z.string().trim().min(5, { message: `Email is required` }).email(`Must be a valid email`),
})

// Editing yourself: name, email and phone are the editable fields, and the role
// selector is disabled, so `roleId` rides along as a hidden input and is not
// required (users migrated before roles existed have none).
export const userWorkspaceSelfValidator = withZod(
  baseSchema
    .extend({
      name: z.string().min(1, { message: `Name is required` }),
      phone: z.string().refine((val) => phonePattern.test(val), { message: `Phone number is not valid` }),
      roleId: z.string().optional(),
    })
    .passthrough(),
) as any

// Editing someone else: their own details are read-only and arrive unchanged,
// so they are only format-checked when present. The role is what you came here
// to set, so it is required.
export const userWorkspaceOtherValidator = withZod(
  baseSchema
    .extend({
      name: z.string().optional(),
      phone: z
        .string()
        .optional()
        .refine((val) => !val?.trim() || phonePattern.test(val), { message: `Phone number is not valid` }),
      roleId: z.string().min(1, { message: `Role is required` }),
    })
    .passthrough(),
) as any
